import type { DefaultOptionType } from 'antd/es/select';
import { I18n } from '@aws-amplify/core';
import type {
	GetCustomReportsRequestDTO,
	GetCustomReportsResponseDTO
} from '@/core/dto/custom-reports/get-custom-reports';

export class GetCustomReportListMapper {
	constructor(private readonly data: GetCustomReportsResponseDTO[] = []) {}

	static toDTO(values: any): GetCustomReportsRequestDTO {
		return {
			organization_id: values.organization_id,
			company_id: values.company_id
		};
	}

	toDomain(): DefaultOptionType[] {
		return this.data.map((value: GetCustomReportsResponseDTO) => ({
			value: value.id,
			label: I18n.get(value.acronym)
		}));
	}
}
